import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, getCurrentInstance } from 'vue'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'BindCard',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const filterData = reactive({
    start_id: '',
    end_id: '',
    status: 0,
});
const onExport = () => {
    if(!filterData.start_id || !filterData.end_id){
        return proxy.$message({ type: 'error', message: '请选择卡区间' })
    }
    window.open(`${Keys.baseUrl}/admin/coupons/get_coupon_infos?${joinParams({...filterData,user_id:store.state.user.userInfo.id})}&is_export=1`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "mb15",
    shadow: "hover"
  }, {
    header: _withCtx(() => _cache[3] || (_cache[3] = [
      _createElementVNode("div", {
        class: "card-header",
        style: {"font-size":"14px","font-weight":"bold"}
      }, [
        _createElementVNode("span", null, "绑卡数据")
      ], -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        class: "filter-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "选择卡区间：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: filterData.start_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterData.start_id) = $event)),
                placeholder: "开始卡id",
                class: "filter-item id-input"
              }, null, 8, ["modelValue"]),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "filter-divider" }, " -- ", -1)),
              _createVNode(_component_el_input, {
                modelValue: filterData.end_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterData.end_id) = $event)),
                placeholder: "结束卡id",
                class: "filter-item id-input"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "选择绑卡状态：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: filterData.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterData.status) = $event)),
                placeholder: "全部绑卡状态",
                class: "filter-item status-select"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部绑卡状态",
                    value: 0
                  }),
                  _createVNode(_component_el_option, {
                    label: "已绑卡",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "未绑卡",
                    value: 2
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: onExport,
                class: "export-btn"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("导出")
                ])),
                _: 1
              }),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "export-note" }, "注：根据号段导出对应的绑卡状态和剩余余额", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})